import {Modal} from 'antd';
import {ReactNode} from 'react';

import {Spinner} from '../../layout/spinner/spinner';
import {classNames} from '../../util/css';

import * as styles from './publication-preview.scss';

type PropsType = {
    isLoading: boolean;
    media?: ReactNode;
    info: ReactNode;
    onClose: VoidFunction;
};

// Generic preview template (modeled on the Yandex stories preview): media carousel on the left, data card on the right.
export function PublicationPreview({isLoading, media, info, onClose}: PropsType): JSX.Element {
    const hasMedia = isLoading || Boolean(media);

    return (
        <Modal
            centered
            className={styles.PublicationPreview_modal}
            closable={false}
            destroyOnClose
            footer={null}
            maskClosable
            onCancel={onClose}
            open
            width={hasMedia ? 880 : 460}
        >
            <div className={styles.PublicationPreview}>
                {hasMedia && (
                    <div className={styles.PublicationPreview_mediaColumn}>
                        {isLoading ? (
                            <Spinner
                                className={classNames(
                                    styles.PublicationPreview_spinner,
                                    styles.PublicationPreview_spinner__dark
                                )}
                            />
                        ) : (
                            media
                        )}
                    </div>
                )}

                <div className={styles.PublicationPreview_infoColumn}>
                    {isLoading ? <Spinner className={styles.PublicationPreview_spinner} /> : info}
                </div>
            </div>
        </Modal>
    );
}
